import Vue from "vue";
import Router from "vue-router";
import store from "@/core/services/store";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout"),
      beforeEnter: (to, from, next) => {
        !store.state.auth.isAuthenticated ? next({ name: "login" }) : next();
      },
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/pages/Dashboard.vue")
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/profile/Profile.vue")
        },

        // --company-management--
        {
          path: "/company-management",
          name: "ComapnyManagementTable",
          component: () =>
            import(
              "@/view/pages/company-management/CompanyManagementTable.vue"
            ),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/company-management/form",
          name: "CompanyManagementFormCreate",
          component: () =>
            import("@/view/pages/company-management/CompanyManagementForm.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/company-management/form/:id",
          name: "CompanyManagementFormUpdate",
          component: () =>
            import("@/view/pages/company-management/CompanyManagementForm.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/company-management/:companyId/campaign",
          name: "CompanyManagementCampaign",
          component: () =>
            import(
              "@/view/pages/company-management/CompanyManagementCampaign.vue"
            ),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/company-management/:companyId/campaign/form/campaign_receipt",
          name: "CompanyManagementCampaignFormCreate",
          component: () =>
            import(
              "@/view/pages/campaign/campaign-receipt-form/CampaignReceiptForm.vue"
            ),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/company-management/:companyId/campaign/form/campaign_receipt/:id",
          name: "CompanyManagementCampaignFormUpdate",
          component: () =>
            import(
              "@/view/pages/campaign/campaign-receipt-form/CampaignReceiptForm.vue"
            ),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        //company
        {
          path: "/company",
          name: "company",
          component: () => import("@/view/pages/company/Company.vue"),
          beforeEnter: (to, from, next) => {
            store.state.auth.userType === 2 ? next() : next("/");
          }
        },
        {
          path: "/custom-color",
          name: "CustomeColor",
          component: () => import("@/view/pages/custom-color/CustomColor.vue"),
          beforeEnter: (to, from, next) => {
            store.state.auth.userType === 2 ? next() : next("/");
          }
        },
        {
          path: "/campaign",
          name: "campaign",
          component: () => import("@/view/pages/campaign/Campaign.vue"),
          beforeEnter: (to, from, next) => {
            store.state.auth.userType === 2 ? next() : next("/");
          }
        },
        {
          path: "/campaign/form/campaign_receipt",
          name: "campaignReceiptFormCreate",
          component: () =>
            import(
              "@/view/pages/campaign/campaign-receipt-form/CampaignReceiptForm.vue"
            ),
          beforeEnter: (to, from, next) => {
            store.state.auth.userType === 2 ||store.state.auth.userType === 1? next() : next("/");
          }
        },
        {
          path: "/campaign/form/campaign_receipt/:campaignId/member/:customerCampaignId/point-history",
          name: "campaignMemberPointHistory",
          redirect: (to) => ({
            path: `/campaign/form/campaign_receipt/${to.params.campaignId}/member/${to.params.customerCampaignId}`,
            query: { ...to.query, tab: "points" }
          })
        },
        {
          path: "/campaign/form/campaign_receipt/:campaignId/member/:customerCampaignId/redemption-history",
          name: "campaignMemberRedemptionHistory",
          redirect: (to) => ({
            path: `/campaign/form/campaign_receipt/${to.params.campaignId}/member/${to.params.customerCampaignId}`,
            query: { ...to.query, tab: "redemption" }
          })
        },
        {
          path: "/campaign/form/campaign_receipt/:campaignId/member/:customerCampaignId",
          name: "campaignMemberDetail",
          component: () =>
            import("@/view/pages/campaign/member/CampaignMemberDetail.vue"),
          beforeEnter: (to, from, next) => {
            store.state.auth.userType === 2 ||
            store.state.auth.userType === 1
              ? next()
              : next("/");
          }
        },
        {
          path: "/campaign/form/campaign_receipt/:id",
          name: "campaignReceiptFormUpdate",
          component: () =>
            import(
              "@/view/pages/campaign/campaign-receipt-form/CampaignReceiptForm.vue"
            ),
          beforeEnter: (to, from, next) => {
            store.state.auth.userType === 2 || store.state.auth.userType === 1 ? next() : next("/");
          }
        },
        {
          path: "/receipt-type",
          name: "receiptTypeTable",
          component: () =>
            import("@/view/pages/receipt-type/ReceiptTypeTable.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/receipt-type/form",
          name: "receiptTypeFormCreate",
          component: () =>
            import("@/view/pages/receipt-type/ReceiptTypeForm.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/receipt-type/form/:id",
          name: "receiptTypeFormUpdate",
          component: () =>
            import("@/view/pages/receipt-type/ReceiptTypeForm.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/user",
          name: "userTable",
          component: () => import("@/view/pages/user/Table.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/user/form",
          name: "userFormCrate",
          component: () => import("@/view/pages/user/form/FormCreate.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        },
        {
          path: "/user/form/:id",
          name: "userFormUpdate",
          component: () => import("@/view/pages/user/form/FormUpdate.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.auth.userType === 1) {
              next();
            } else {
              next("/");
            }
          }
        }
      ]
    },

    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue")
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue")
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue")
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue")
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/login/Login"),
      beforeEnter: (to, from, next) => {
        store.state.auth.isAuthenticated ? next({ name: "dashboard" }) : next();
      },
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/login/Login")
        }
      ]
    },
    {
      path: "/verify-register",
      name: "verifyRegister",
      component: () => import("@/view/pages/verify-register/verifyRegister")
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
